// @generated by protoc-gen-es v2.14.0 with parameter "target=ts,import_extension=none"
// @generated from file version.proto (package puppy.proto.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "./google/protobuf/timestamp_pb";
import { file_google_protobuf_timestamp } from "./google/protobuf/timestamp_pb";
import type { EmptyResponseSchema } from "./basic_pb";
import { file_basic } from "./basic_pb";
import type { FileInfo } from "./file_pb";
import { file_file } from "./file_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file version.proto.
 */
export const file_version: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_basic, file_file]);

/**
 * 仓库信息
 *
 * @generated from message puppy.proto.v1.RepositoryInfo
 */
export type RepositoryInfo = Message<"puppy.proto.v1.RepositoryInfo"> & {
  /**
   * 仓库 ID（version_repositories.id）
   *
   * @generated from field: uint64 repository_id = 1;
   */
  repositoryId: bigint;

  /**
   * 是否已初始化为仓库
   *
   * @generated from field: bool initialized = 2;
   */
  initialized: boolean;

  /**
   * 默认分支 ID（version_branches.id）
   *
   * @generated from field: uint64 default_branch_id = 3;
   */
  defaultBranchId: bigint;

  /**
   * 默认分支名
   *
   * @generated from field: string default_branch_name = 4;
   */
  defaultBranchName: string;

  /**
   * 默认分支 HEAD 提交 ID
   *
   * @generated from field: string head_commit_id = 5;
   */
  headCommitId: string;

  /**
   * 最近提交时间
   *
   * @generated from field: google.protobuf.Timestamp latest_commit_at = 6;
   */
  latestCommitAt?: Timestamp | undefined;
};

/**
 * Describes the message puppy.proto.v1.RepositoryInfo.
 * Use `create(RepositoryInfoSchema)` to create a new message.
 */
export const RepositoryInfoSchema: GenMessage<RepositoryInfo> = /*@__PURE__*/
  messageDesc(file_version, 0);

/**
 * 提交信息
 *
 * @generated from message puppy.proto.v1.CommitInfo
 */
export type CommitInfo = Message<"puppy.proto.v1.CommitInfo"> & {
  /**
   * 仓库 ID（version_repositories.id）
   *
   * @generated from field: uint64 repository_id = 1;
   */
  repositoryId: bigint;

  /**
   * 提交 ID
   *
   * @generated from field: string commit_id = 2;
   */
  commitId: string;

  /**
   * 父提交 ID 列表（merge commit 可有多个）
   *
   * @generated from field: repeated string parent_commit_ids = 3;
   */
  parentCommitIds: string[];

  /**
   * 提交说明
   *
   * @generated from field: string message = 6;
   */
  message: string;

  /**
   * 提交人标识
   *
   * @generated from field: string created_by = 7;
   */
  createdBy: string;

  /**
   * 创建时间
   *
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp | undefined;
};

/**
 * Describes the message puppy.proto.v1.CommitInfo.
 * Use `create(CommitInfoSchema)` to create a new message.
 */
export const CommitInfoSchema: GenMessage<CommitInfo> = /*@__PURE__*/
  messageDesc(file_version, 1);

/**
 * 分支信息
 *
 * @generated from message puppy.proto.v1.BranchInfo
 */
export type BranchInfo = Message<"puppy.proto.v1.BranchInfo"> & {
  /**
   * 分支 ID（version_branches.id）
   *
   * @generated from field: uint64 branch_id = 1;
   */
  branchId: bigint;

  /**
   * 分支名
   *
   * @generated from field: string branch_name = 3;
   */
  branchName: string;

  /**
   * 仓库 ID（version_repositories.id）
   *
   * @generated from field: uint64 repository_id = 2;
   */
  repositoryId: bigint;

  /**
   * 分支头提交 ID
   *
   * @generated from field: string head_commit_id = 4;
   */
  headCommitId: string;

  /**
   * 分支最近提交时间
   *
   * @generated from field: google.protobuf.Timestamp latest_commit_at = 5;
   */
  latestCommitAt?: Timestamp | undefined;

  /**
   * 分支用途类型
   *
   * @generated from field: puppy.proto.v1.BranchKind branch_kind = 6;
   */
  branchKind: BranchKind;

  /**
   * 创建者标识
   *
   * @generated from field: string created_by = 7;
   */
  createdBy: string;

  /**
   * 当前分支负责人用户 ID；未分配时为 0
   *
   * @generated from field: uint64 assignee_user_id = 8;
   */
  assigneeUserId: bigint;

  /**
   * 工作区分支基于的来源分支 ID；非 workspace 分支为 0
   *
   * @generated from field: uint64 base_on_branch = 9;
   */
  baseOnBranch: bigint;

  /**
   * 当前请求用户是否可编辑该分支；仅 assignee 可编辑
   *
   * @generated from field: bool can_edit = 10;
   */
  canEdit: boolean;

  /**
   * assignee_user_id 对应的用户名；未分配或用户不存在时为空
   *
   * @generated from field: string assignee_username = 11;
   */
  assigneeUsername: string;

  /**
   * 分支头提交说明；无 HEAD 提交时为空
   *
   * @generated from field: string head_commit_info = 12;
   */
  headCommitInfo: string;

  /**
   * 是否为默认分支；仅默认分支返回 true，其他分支不返回
   *
   * @generated from field: optional bool is_default = 13;
   */
  isDefault?: boolean | undefined;
};

/**
 * Describes the message puppy.proto.v1.BranchInfo.
 * Use `create(BranchInfoSchema)` to create a new message.
 */
export const BranchInfoSchema: GenMessage<BranchInfo> = /*@__PURE__*/
  messageDesc(file_version, 2);

/**
 * 标签信息
 *
 * @generated from message puppy.proto.v1.TagInfo
 */
export type TagInfo = Message<"puppy.proto.v1.TagInfo"> & {
  /**
   * 仓库 ID（version_repositories.id）
   *
   * @generated from field: uint64 repository_id = 1;
   */
  repositoryId: bigint;

  /**
   * 标签名
   *
   * @generated from field: string tag_name = 2;
   */
  tagName: string;

  /**
   * 标签指向的提交 ID
   *
   * @generated from field: string commit_id = 3;
   */
  commitId: string;

  /**
   * 标签说明（可为空）
   *
   * @generated from field: string message = 4;
   */
  message: string;

  /**
   * 创建人标识
   *
   * @generated from field: string created_by = 5;
   */
  createdBy: string;

  /**
   * 创建时间
   *
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp | undefined;
};

/**
 * Describes the message puppy.proto.v1.TagInfo.
 * Use `create(TagInfoSchema)` to create a new message.
 */
export const TagInfoSchema: GenMessage<TagInfo> = /*@__PURE__*/
  messageDesc(file_version, 3);

/**
 * 树条目变更
 *
 * @generated from message puppy.proto.v1.TreeEntryChange
 */
export type TreeEntryChange = Message<"puppy.proto.v1.TreeEntryChange"> & {
  /**
   * 当前路径（相对仓库根）
   *
   * @generated from field: string path = 1;
   */
  path: string;

  /**
   * 条目类型
   *
   * @generated from field: puppy.proto.v1.RepositoryEntryKind kind = 2;
   */
  kind: RepositoryEntryKind;

  /**
   * 变更类型
   *
   * @generated from field: puppy.proto.v1.ChangeType change_type = 3;
   */
  changeType: ChangeType;

  /**
   * 重命名时的旧路径
   *
   * @generated from field: string old_path = 4;
   */
  oldPath: string;

  /**
   * 文件大小（文件/快照统计时可返回）
   *
   * @generated from field: uint64 size = 5;
   */
  size: bigint;

  /**
   * 文件类型：沿用 FileInfo.kind 风格
   *
   * @generated from field: string file_kind = 6;
   */
  fileKind: string;
};

/**
 * Describes the message puppy.proto.v1.TreeEntryChange.
 * Use `create(TreeEntryChangeSchema)` to create a new message.
 */
export const TreeEntryChangeSchema: GenMessage<TreeEntryChange> = /*@__PURE__*/
  messageDesc(file_version, 4);

/**
 * 获取仓库信息请求
 *
 * @generated from message puppy.proto.v1.GetRepositoryRequest
 */
export type GetRepositoryRequest = Message<"puppy.proto.v1.GetRepositoryRequest"> & {
  /**
   * 仓库 ID（version_repositories.id）
   *
   * @generated from field: uint64 repository_id = 1;
   */
  repositoryId: bigint;
};

/**
 * Describes the message puppy.proto.v1.GetRepositoryRequest.
 * Use `create(GetRepositoryRequestSchema)` to create a new message.
 */
export const GetRepositoryRequestSchema: GenMessage<GetRepositoryRequest> = /*@__PURE__*/
  messageDesc(file_version, 5);

/**
 * 比较两个提交差异请求
 *
 * @generated from message puppy.proto.v1.DiffCommitsRequest
 */
export type DiffCommitsRequest = Message<"puppy.proto.v1.DiffCommitsRequest"> & {
  /**
   * 仓库 ID（version_repositories.id）
   *
   * @generated from field: uint64 repository_id = 1;
   */
  repositoryId: bigint;

  /**
   * 起始提交 ID
   *
   * @generated from field: string from_commit_id = 2;
   */
  fromCommitId: string;

  /**
   * 目标提交 ID
   *
   * @generated from field: string to_commit_id = 3;
   */
  toCommitId: string;

  /**
   * 可选：仅查看仓库内某个子路径前缀
   *
   * @generated from field: optional string path_prefix = 4;
   */
  pathPrefix?: string | undefined;
};

/**
 * Describes the message puppy.proto.v1.DiffCommitsRequest.
 * Use `create(DiffCommitsRequestSchema)` to create a new message.
 */
export const DiffCommitsRequestSchema: GenMessage<DiffCommitsRequest> = /*@__PURE__*/
  messageDesc(file_version, 6);

/**
 * 比较两个提交差异响应
 *
 * @generated from message puppy.proto.v1.DiffCommitsResponse
 */
export type DiffCommitsResponse = Message<"puppy.proto.v1.DiffCommitsResponse"> & {
  /**
   * 文件级变更列表
   *
   * @generated from field: repeated puppy.proto.v1.TreeEntryChange changes = 1;
   */
  changes: TreeEntryChange[];
};

/**
 * Describes the message puppy.proto.v1.DiffCommitsResponse.
 * Use `create(DiffCommitsResponseSchema)` to create a new message.
 */
export const DiffCommitsResponseSchema: GenMessage<DiffCommitsResponse> = /*@__PURE__*/
  messageDesc(file_version, 7);

/**
 * 检出指定提交的文件列表请求
 *
 * @generated from message puppy.proto.v1.CheckoutCommitFilesRequest
 */
export type CheckoutCommitFilesRequest = Message<"puppy.proto.v1.CheckoutCommitFilesRequest"> & {
  /**
   * 仓库 ID（version_repositories.id）
   *
   * @generated from field: uint64 repository_id = 1;
   */
  repositoryId: bigint;

  /**
   * 提交 ID
   *
   * @generated from field: string commit_id = 2;
   */
  commitId: string;

  /**
   * 可选：仅返回仓库内某个目录前缀下的文件
   *
   * @generated from field: optional string folder_id = 3;
   */
  folderId?: string | undefined;

  /**
   * 类型过滤：file / folder / cad / all / .ext（空=all）
   *
   * @generated from field: string kind = 4;
   */
  kind: string;

  /**
   * 页码（从 1 开始；<=0 视为 1）
   *
   * @generated from field: int32 page = 5;
   */
  page: number;

  /**
   * 每页条数（<=0 默认；最大值由服务端限制）
   *
   * @generated from field: int32 limit = 6;
   */
  limit: number;
};

/**
 * Describes the message puppy.proto.v1.CheckoutCommitFilesRequest.
 * Use `create(CheckoutCommitFilesRequestSchema)` to create a new message.
 */
export const CheckoutCommitFilesRequestSchema: GenMessage<CheckoutCommitFilesRequest> = /*@__PURE__*/
  messageDesc(file_version, 8);

/**
 * 检出指定提交的文件列表响应
 *
 * @generated from message puppy.proto.v1.CheckoutCommitFilesResponse
 */
export type CheckoutCommitFilesResponse = Message<"puppy.proto.v1.CheckoutCommitFilesResponse"> & {
  /**
   * 指定提交对应的文件列表
   *
   * @generated from field: repeated puppy.proto.v1.FileInfo files = 1;
   */
  files: FileInfo[];

  /**
   * 总数（用于分页）
   *
   * @generated from field: int32 total = 2;
   */
  total: number;

  /**
   * 本次检出的提交 ID
   *
   * @generated from field: string commit_id = 3;
   */
  commitId: string;
};

/**
 * Describes the message puppy.proto.v1.CheckoutCommitFilesResponse.
 * Use `create(CheckoutCommitFilesResponseSchema)` to create a new message.
 */
export const CheckoutCommitFilesResponseSchema: GenMessage<CheckoutCommitFilesResponse> = /*@__PURE__*/
  messageDesc(file_version, 9);

/**
 * 提交文件到分支中的单个变更项
 *
 * @generated from message puppy.proto.v1.CommitBranchChange
 */
export type CommitBranchChange = Message<"puppy.proto.v1.CommitBranchChange"> & {
  /**
   * 变更类型：新增/修改/删除/重命名
   *
   * @generated from field: puppy.proto.v1.ChangeType change_type = 1;
   */
  changeType: ChangeType;

  /**
   * 条目类型：file / folder
   *
   * @generated from field: puppy.proto.v1.RepositoryEntryKind kind = 2;
   */
  kind: RepositoryEntryKind;

  /**
   * 变更后的路径（相对仓库根）
   *
   * @generated from field: string path = 3;
   */
  path: string;

  /**
   * 业务 UUID（文件修改/删除时必填；新增时可为空由服务端生成）
   *
   * @generated from field: string file_uuid = 4;
   */
  fileUuid: string;

  /**
   * 重命名时的旧路径
   *
   * @generated from field: string old_path = 5;
   */
  oldPath: string;

  /**
   * 文件内容大小（文件新增/修改且携带 chunk 时必填）
   *
   * @generated from field: uint64 content_size = 8;
   */
  contentSize: bigint;
};

/**
 * Describes the message puppy.proto.v1.CommitBranchChange.
 * Use `create(CommitBranchChangeSchema)` to create a new message.
 */
export const CommitBranchChangeSchema: GenMessage<CommitBranchChange> = /*@__PURE__*/
  messageDesc(file_version, 10);

/**
 * 提交文件到分支元数据（首帧）
 *
 * @generated from message puppy.proto.v1.CommitFilesToBranchMetadata
 */
export type CommitFilesToBranchMetadata = Message<"puppy.proto.v1.CommitFilesToBranchMetadata"> & {
  /**
   * 仓库 ID（version_repositories.id）
   *
   * @generated from field: uint64 repository_id = 1;
   */
  repositoryId: bigint;

  /**
   * 目标分支 ID；0 表示默认分支
   *
   * @generated from field: uint64 branch_id = 2;
   */
  branchId: bigint;

  /**
   * 提交说明
   *
   * @generated from field: string message = 3;
   */
  message: string;

  /**
   * 基于哪个提交生成本次提交流；首个提交可为空字符串
   *
   * @generated from field: string base_commit_id = 4;
   */
  baseCommitId: string;
};

/**
 * Describes the message puppy.proto.v1.CommitFilesToBranchMetadata.
 * Use `create(CommitFilesToBranchMetadataSchema)` to create a new message.
 */
export const CommitFilesToBranchMetadataSchema: GenMessage<CommitFilesToBranchMetadata> = /*@__PURE__*/
  messageDesc(file_version, 11);

/**
 * 提交文件到分支请求（客户端流）
 * 约定：
 * - 首帧必须是 metadata
 * - 后续帧按 change -> chunk* 的顺序组织
 * - 仅当 change 表示文件新增/修改时，才允许后续跟随 chunk
 * - 删除/重命名不应跟随 chunk
 *
 * @generated from message puppy.proto.v1.CommitFilesToBranchRequest
 */
export type CommitFilesToBranchRequest = Message<"puppy.proto.v1.CommitFilesToBranchRequest"> & {
  /**
   * @generated from oneof puppy.proto.v1.CommitFilesToBranchRequest.payload
   */
  payload: {
    /**
     * 首帧必须是提交元数据
     *
     * @generated from field: puppy.proto.v1.CommitFilesToBranchMetadata metadata = 1;
     */
    value: CommitFilesToBranchMetadata;
    case: "metadata";
  } | {
    /**
     * 声明一个变更项
     *
     * @generated from field: puppy.proto.v1.CommitBranchChange change = 2;
     */
    value: CommitBranchChange;
    case: "change";
  } | {
    /**
     * 当前文件变更的后续内容块
     *
     * @generated from field: bytes chunk = 3;
     */
    value: Uint8Array;
    case: "chunk";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message puppy.proto.v1.CommitFilesToBranchRequest.
 * Use `create(CommitFilesToBranchRequestSchema)` to create a new message.
 */
export const CommitFilesToBranchRequestSchema: GenMessage<CommitFilesToBranchRequest> = /*@__PURE__*/
  messageDesc(file_version, 12);

/**
 * 获取提交历史请求
 *
 * @generated from message puppy.proto.v1.ListCommitsRequest
 */
export type ListCommitsRequest = Message<"puppy.proto.v1.ListCommitsRequest"> & {
  /**
   * 仓库 ID（version_repositories.id）
   *
   * @generated from field: uint64 repository_id = 1;
   */
  repositoryId: bigint;

  /**
   * 可选：仅查看指定分支历史；为空时返回所有分支的提交记录
   *
   * @generated from field: optional uint64 branch_id = 2;
   */
  branchId?: bigint | undefined;

  /**
   * 页码（从 1 开始；<=0 视为 1）
   *
   * @generated from field: int32 page = 3;
   */
  page: number;

  /**
   * 每页条数（<=0 默认；最大值由服务端限制）
   *
   * @generated from field: int32 limit = 4;
   */
  limit: number;

  /**
   * 可选：按分支用途类型筛选；为空时返回全部类型
   *
   * @generated from field: optional puppy.proto.v1.BranchKind branch_kind = 5;
   */
  branchKind?: BranchKind | undefined;

  /**
   * 可选：按来源分支 ID 筛选；为空时返回全部来源
   *
   * @generated from field: optional uint64 base_on_branch = 6;
   */
  baseOnBranch?: bigint | undefined;
};

/**
 * Describes the message puppy.proto.v1.ListCommitsRequest.
 * Use `create(ListCommitsRequestSchema)` to create a new message.
 */
export const ListCommitsRequestSchema: GenMessage<ListCommitsRequest> = /*@__PURE__*/
  messageDesc(file_version, 13);

/**
 * 获取提交历史响应
 *
 * @generated from message puppy.proto.v1.ListCommitsResponse
 */
export type ListCommitsResponse = Message<"puppy.proto.v1.ListCommitsResponse"> & {
  /**
   * 提交列表
   *
   * @generated from field: repeated puppy.proto.v1.CommitInfo commits = 1;
   */
  commits: CommitInfo[];

  /**
   * 总数（用于分页）
   *
   * @generated from field: int32 total = 2;
   */
  total: number;

  /**
   * 本次命中的分支信息列表
   *
   * @generated from field: repeated puppy.proto.v1.BranchInfo branches = 3;
   */
  branches: BranchInfo[];
};

/**
 * Describes the message puppy.proto.v1.ListCommitsResponse.
 * Use `create(ListCommitsResponseSchema)` to create a new message.
 */
export const ListCommitsResponseSchema: GenMessage<ListCommitsResponse> = /*@__PURE__*/
  messageDesc(file_version, 14);

/**
 * 获取指定提交中的指定文件内容请求
 *
 * @generated from message puppy.proto.v1.GetCommitFileRequest
 */
export type GetCommitFileRequest = Message<"puppy.proto.v1.GetCommitFileRequest"> & {
  /**
   * 仓库 ID（version_repositories.id）
   *
   * @generated from field: uint64 repository_id = 1;
   */
  repositoryId: bigint;

  /**
   * 提交 ID
   *
   * @generated from field: string commit_id = 2;
   */
  commitId: string;

  /**
   * 提交内文件路径（相对仓库根）
   *
   * @generated from field: string path = 3;
   */
  path: string;

  /**
   * 业务 UUID（可选：用于精确定位文件版本）
   *
   * @generated from field: string file_uuid = 4;
   */
  fileUuid: string;
};

/**
 * Describes the message puppy.proto.v1.GetCommitFileRequest.
 * Use `create(GetCommitFileRequestSchema)` to create a new message.
 */
export const GetCommitFileRequestSchema: GenMessage<GetCommitFileRequest> = /*@__PURE__*/
  messageDesc(file_version, 15);

/**
 * 获取指定提交中的指定文件内容响应
 *
 * @generated from message puppy.proto.v1.GetCommitFileResponse
 */
export type GetCommitFileResponse = Message<"puppy.proto.v1.GetCommitFileResponse"> & {
  /**
   * 文件总大小（字节）
   *
   * @generated from field: uint64 total_size = 1;
   */
  totalSize: bigint;

  /**
   * 文件内容块
   *
   * @generated from field: bytes chunk = 2;
   */
  chunk: Uint8Array;
};

/**
 * Describes the message puppy.proto.v1.GetCommitFileResponse.
 * Use `create(GetCommitFileResponseSchema)` to create a new message.
 */
export const GetCommitFileResponseSchema: GenMessage<GetCommitFileResponse> = /*@__PURE__*/
  messageDesc(file_version, 16);

/**
 * 恢复指定提交请求
 *
 * @generated from message puppy.proto.v1.RestoreCommitRequest
 */
export type RestoreCommitRequest = Message<"puppy.proto.v1.RestoreCommitRequest"> & {
  /**
   * 仓库 ID（version_repositories.id）
   *
   * @generated from field: uint64 repository_id = 1;
   */
  repositoryId: bigint;

  /**
   * 目标分支 ID；0 表示默认分支
   *
   * @generated from field: uint64 branch_id = 2;
   */
  branchId: bigint;

  /**
   * 待恢复的目标提交 ID
   *
   * @generated from field: string commit_id = 3;
   */
  commitId: string;

  /**
   * 恢复操作生成的新提交说明
   *
   * @generated from field: string message = 4;
   */
  message: string;

  /**
   * 基于哪个提交执行恢复；分支已有提交时必填
   *
   * @generated from field: string base_commit_id = 5;
   */
  baseCommitId: string;
};

/**
 * Describes the message puppy.proto.v1.RestoreCommitRequest.
 * Use `create(RestoreCommitRequestSchema)` to create a new message.
 */
export const RestoreCommitRequestSchema: GenMessage<RestoreCommitRequest> = /*@__PURE__*/
  messageDesc(file_version, 17);

/**
 * 恢复指定提交响应
 *
 * @generated from message puppy.proto.v1.RestoreCommitResponse
 */
export type RestoreCommitResponse = Message<"puppy.proto.v1.RestoreCommitResponse"> & {
  /**
   * 恢复后的仓库信息
   *
   * @generated from field: puppy.proto.v1.RepositoryInfo repository = 1;
   */
  repository?: RepositoryInfo | undefined;

  /**
   * 恢复动作生成的新提交
   *
   * @generated from field: puppy.proto.v1.CommitInfo created_commit = 2;
   */
  createdCommit?: CommitInfo | undefined;
};

/**
 * Describes the message puppy.proto.v1.RestoreCommitResponse.
 * Use `create(RestoreCommitResponseSchema)` to create a new message.
 */
export const RestoreCommitResponseSchema: GenMessage<RestoreCommitResponse> = /*@__PURE__*/
  messageDesc(file_version, 18);

/**
 * 获取分支列表请求
 *
 * @generated from message puppy.proto.v1.ListBranchesRequest
 */
export type ListBranchesRequest = Message<"puppy.proto.v1.ListBranchesRequest"> & {
  /**
   * 仓库 ID（version_repositories.id）
   *
   * @generated from field: uint64 repository_id = 1;
   */
  repositoryId: bigint;

  /**
   * 可选：项目 ID；传入后要求仓库属于该项目上下文
   *
   * @generated from field: optional uint64 project_id = 2;
   */
  projectId?: bigint | undefined;
};

/**
 * Describes the message puppy.proto.v1.ListBranchesRequest.
 * Use `create(ListBranchesRequestSchema)` to create a new message.
 */
export const ListBranchesRequestSchema: GenMessage<ListBranchesRequest> = /*@__PURE__*/
  messageDesc(file_version, 19);

/**
 * 获取分支列表响应
 *
 * @generated from message puppy.proto.v1.ListBranchesResponse
 */
export type ListBranchesResponse = Message<"puppy.proto.v1.ListBranchesResponse"> & {
  /**
   * 分支列表
   *
   * @generated from field: repeated puppy.proto.v1.BranchInfo branches = 1;
   */
  branches: BranchInfo[];
};

/**
 * Describes the message puppy.proto.v1.ListBranchesResponse.
 * Use `create(ListBranchesResponseSchema)` to create a new message.
 */
export const ListBranchesResponseSchema: GenMessage<ListBranchesResponse> = /*@__PURE__*/
  messageDesc(file_version, 20);

/**
 * 获取标签列表请求
 *
 * @generated from message puppy.proto.v1.ListTagsRequest
 */
export type ListTagsRequest = Message<"puppy.proto.v1.ListTagsRequest"> & {
  /**
   * 仓库 ID（version_repositories.id）
   *
   * @generated from field: uint64 repository_id = 1;
   */
  repositoryId: bigint;

  /**
   * 页码（从 1 开始；<=0 视为 1）
   *
   * @generated from field: int32 page = 2;
   */
  page: number;

  /**
   * 每页条数（<=0 默认；最大值由服务端限制）
   *
   * @generated from field: int32 limit = 3;
   */
  limit: number;
};

/**
 * Describes the message puppy.proto.v1.ListTagsRequest.
 * Use `create(ListTagsRequestSchema)` to create a new message.
 */
export const ListTagsRequestSchema: GenMessage<ListTagsRequest> = /*@__PURE__*/
  messageDesc(file_version, 21);

/**
 * 获取标签列表响应
 *
 * @generated from message puppy.proto.v1.ListTagsResponse
 */
export type ListTagsResponse = Message<"puppy.proto.v1.ListTagsResponse"> & {
  /**
   * 标签列表
   *
   * @generated from field: repeated puppy.proto.v1.TagInfo tags = 1;
   */
  tags: TagInfo[];

  /**
   * 总数（用于分页）
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message puppy.proto.v1.ListTagsResponse.
 * Use `create(ListTagsResponseSchema)` to create a new message.
 */
export const ListTagsResponseSchema: GenMessage<ListTagsResponse> = /*@__PURE__*/
  messageDesc(file_version, 22);

/**
 * 创建分支请求
 *
 * @generated from message puppy.proto.v1.CreateBranchRequest
 */
export type CreateBranchRequest = Message<"puppy.proto.v1.CreateBranchRequest"> & {
  /**
   * 仓库 ID（version_repositories.id）
   *
   * @generated from field: uint64 repository_id = 1;
   */
  repositoryId: bigint;

  /**
   * 新分支名
   *
   * @generated from field: string branch_name = 2;
   */
  branchName: string;

  /**
   * 可选：新分支的起始提交 ID；为空时创建空分支
   *
   * @generated from field: string from_commit_id = 3;
   */
  fromCommitId: string;

  /**
   * 可选：分支用途类型；为空时默认普通分支
   *
   * @generated from field: optional puppy.proto.v1.BranchKind branch_kind = 4;
   */
  branchKind?: BranchKind | undefined;
};

/**
 * Describes the message puppy.proto.v1.CreateBranchRequest.
 * Use `create(CreateBranchRequestSchema)` to create a new message.
 */
export const CreateBranchRequestSchema: GenMessage<CreateBranchRequest> = /*@__PURE__*/
  messageDesc(file_version, 23);

/**
 * 创建标签请求
 *
 * @generated from message puppy.proto.v1.CreateTagRequest
 */
export type CreateTagRequest = Message<"puppy.proto.v1.CreateTagRequest"> & {
  /**
   * 仓库 ID（version_repositories.id）
   *
   * @generated from field: uint64 repository_id = 1;
   */
  repositoryId: bigint;

  /**
   * 标签名
   *
   * @generated from field: string tag_name = 2;
   */
  tagName: string;

  /**
   * 标签指向的提交 ID
   *
   * @generated from field: string commit_id = 3;
   */
  commitId: string;

  /**
   * 标签说明（可为空）
   *
   * @generated from field: string message = 4;
   */
  message: string;
};

/**
 * Describes the message puppy.proto.v1.CreateTagRequest.
 * Use `create(CreateTagRequestSchema)` to create a new message.
 */
export const CreateTagRequestSchema: GenMessage<CreateTagRequest> = /*@__PURE__*/
  messageDesc(file_version, 24);

/**
 * 删除分支请求
 *
 * @generated from message puppy.proto.v1.DeleteBranchRequest
 */
export type DeleteBranchRequest = Message<"puppy.proto.v1.DeleteBranchRequest"> & {
  /**
   * 仓库 ID（version_repositories.id）
   *
   * @generated from field: uint64 repository_id = 1;
   */
  repositoryId: bigint;

  /**
   * 待删除分支 ID
   *
   * @generated from field: uint64 branch_id = 2;
   */
  branchId: bigint;
};

/**
 * Describes the message puppy.proto.v1.DeleteBranchRequest.
 * Use `create(DeleteBranchRequestSchema)` to create a new message.
 */
export const DeleteBranchRequestSchema: GenMessage<DeleteBranchRequest> = /*@__PURE__*/
  messageDesc(file_version, 25);

/**
 * 删除标签请求
 *
 * @generated from message puppy.proto.v1.DeleteTagRequest
 */
export type DeleteTagRequest = Message<"puppy.proto.v1.DeleteTagRequest"> & {
  /**
   * 仓库 ID（version_repositories.id）
   *
   * @generated from field: uint64 repository_id = 1;
   */
  repositoryId: bigint;

  /**
   * 待删除标签名
   *
   * @generated from field: string tag_name = 2;
   */
  tagName: string;
};

/**
 * Describes the message puppy.proto.v1.DeleteTagRequest.
 * Use `create(DeleteTagRequestSchema)` to create a new message.
 */
export const DeleteTagRequestSchema: GenMessage<DeleteTagRequest> = /*@__PURE__*/
  messageDesc(file_version, 26);

/**
 * 合并分支请求
 *
 * @generated from message puppy.proto.v1.MergeBranchRequest
 */
export type MergeBranchRequest = Message<"puppy.proto.v1.MergeBranchRequest"> & {
  /**
   * 仓库 ID（version_repositories.id）
   *
   * @generated from field: uint64 repository_id = 1;
   */
  repositoryId: bigint;

  /**
   * 源分支 ID
   *
   * @generated from field: uint64 source_branch_id = 2;
   */
  sourceBranchId: bigint;

  /**
   * 目标分支 ID
   *
   * @generated from field: uint64 target_branch_id = 3;
   */
  targetBranchId: bigint;

  /**
   * merge commit 说明
   *
   * @generated from field: string message = 4;
   */
  message: string;
};

/**
 * Describes the message puppy.proto.v1.MergeBranchRequest.
 * Use `create(MergeBranchRequestSchema)` to create a new message.
 */
export const MergeBranchRequestSchema: GenMessage<MergeBranchRequest> = /*@__PURE__*/
  messageDesc(file_version, 27);

/**
 * 合并结果
 *
 * @generated from message puppy.proto.v1.MergeResult
 */
export type MergeResult = Message<"puppy.proto.v1.MergeResult"> & {
  /**
   * 是否存在冲突
   *
   * @generated from field: bool has_conflicts = 1;
   */
  hasConflicts: boolean;

  /**
   * 无冲突时返回 merge commit
   *
   * @generated from field: puppy.proto.v1.CommitInfo merge_commit = 2;
   */
  mergeCommit?: CommitInfo | undefined;

  /**
   * 冲突路径列表
   *
   * @generated from field: repeated string conflict_paths = 3;
   */
  conflictPaths: string[];
};

/**
 * Describes the message puppy.proto.v1.MergeResult.
 * Use `create(MergeResultSchema)` to create a new message.
 */
export const MergeResultSchema: GenMessage<MergeResult> = /*@__PURE__*/
  messageDesc(file_version, 28);

/**
 * 仓库树条目类型
 *
 * @generated from enum puppy.proto.v1.RepositoryEntryKind
 */
export enum RepositoryEntryKind {
  /**
   * @generated from enum value: REPOSITORY_ENTRY_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: REPOSITORY_ENTRY_KIND_FILE = 1;
   */
  FILE = 1,

  /**
   * @generated from enum value: REPOSITORY_ENTRY_KIND_FOLDER = 2;
   */
  FOLDER = 2,
}

/**
 * Describes the enum puppy.proto.v1.RepositoryEntryKind.
 */
export const RepositoryEntryKindSchema: GenEnum<RepositoryEntryKind> = /*@__PURE__*/
  enumDesc(file_version, 0);

/**
 * 仓库变更类型
 *
 * @generated from enum puppy.proto.v1.ChangeType
 */
export enum ChangeType {
  /**
   * @generated from enum value: CHANGE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CHANGE_TYPE_ADDED = 1;
   */
  ADDED = 1,

  /**
   * @generated from enum value: CHANGE_TYPE_MODIFIED = 2;
   */
  MODIFIED = 2,

  /**
   * @generated from enum value: CHANGE_TYPE_DELETED = 3;
   */
  DELETED = 3,

  /**
   * @generated from enum value: CHANGE_TYPE_RENAMED = 4;
   */
  RENAMED = 4,
}

/**
 * Describes the enum puppy.proto.v1.ChangeType.
 */
export const ChangeTypeSchema: GenEnum<ChangeType> = /*@__PURE__*/
  enumDesc(file_version, 1);

/**
 * 分支用途类型
 *
 * @generated from enum puppy.proto.v1.BranchKind
 */
export enum BranchKind {
  /**
   * @generated from enum value: BRANCH_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 普通分支
   *
   * @generated from enum value: BRANCH_KIND_NORMAL = 1;
   */
  NORMAL = 1,

  /**
   * 用户暂存分支
   *
   * @generated from enum value: BRANCH_KIND_STAGING = 2;
   */
  STAGING = 2,

  /**
   * 自动保存分支
   *
   * @generated from enum value: BRANCH_KIND_AUTOSAVE = 3;
   */
  AUTOSAVE = 3,

  /**
   * 工作区分支
   *
   * @generated from enum value: BRANCH_KIND_WORKSPACE = 4;
   */
  WORKSPACE = 4,
}

/**
 * Describes the enum puppy.proto.v1.BranchKind.
 */
export const BranchKindSchema: GenEnum<BranchKind> = /*@__PURE__*/
  enumDesc(file_version, 2);

/**
 * 版本控制服务（CAD 版本仓库）
 *
 * @generated from service puppy.proto.v1.VersionControlService
 */
export const VersionControlService: GenService<{
  /**
   * 获取仓库信息
   *
   * @generated from rpc puppy.proto.v1.VersionControlService.GetRepository
   */
  getRepository: {
    methodKind: "unary";
    input: typeof GetRepositoryRequestSchema;
    output: typeof RepositoryInfoSchema;
  },
  /**
   * 比较两个提交的差异
   *
   * @generated from rpc puppy.proto.v1.VersionControlService.DiffCommits
   */
  diffCommits: {
    methodKind: "unary";
    input: typeof DiffCommitsRequestSchema;
    output: typeof DiffCommitsResponseSchema;
  },
  /**
   * 检出指定提交的文件列表
   *
   * @generated from rpc puppy.proto.v1.VersionControlService.CheckoutCommitFiles
   */
  checkoutCommitFiles: {
    methodKind: "unary";
    input: typeof CheckoutCommitFilesRequestSchema;
    output: typeof CheckoutCommitFilesResponseSchema;
  },
  /**
   * 提交文件到分支（客户端流：首帧必须是提交元数据；文件变更可跟随 chunk）
   *
   * @generated from rpc puppy.proto.v1.VersionControlService.CommitFilesToBranch
   */
  commitFilesToBranch: {
    methodKind: "client_streaming";
    input: typeof CommitFilesToBranchRequestSchema;
    output: typeof CommitInfoSchema;
  },
  /**
   * 获取提交历史
   *
   * @generated from rpc puppy.proto.v1.VersionControlService.ListCommits
   */
  listCommits: {
    methodKind: "unary";
    input: typeof ListCommitsRequestSchema;
    output: typeof ListCommitsResponseSchema;
  },
  /**
   * 获取指定提交中的指定文件内容（服务端流式返回）
   *
   * @generated from rpc puppy.proto.v1.VersionControlService.GetCommitFile
   */
  getCommitFile: {
    methodKind: "server_streaming";
    input: typeof GetCommitFileRequestSchema;
    output: typeof GetCommitFileResponseSchema;
  },
  /**
   * 恢复到指定提交（恢复操作本身会创建新提交）
   *
   * @generated from rpc puppy.proto.v1.VersionControlService.RestoreCommit
   */
  restoreCommit: {
    methodKind: "unary";
    input: typeof RestoreCommitRequestSchema;
    output: typeof RestoreCommitResponseSchema;
  },
  /**
   * 获取分支列表
   *
   * @generated from rpc puppy.proto.v1.VersionControlService.ListBranches
   */
  listBranches: {
    methodKind: "unary";
    input: typeof ListBranchesRequestSchema;
    output: typeof ListBranchesResponseSchema;
  },
  /**
   * 获取标签列表
   *
   * @generated from rpc puppy.proto.v1.VersionControlService.ListTags
   */
  listTags: {
    methodKind: "unary";
    input: typeof ListTagsRequestSchema;
    output: typeof ListTagsResponseSchema;
  },
  /**
   * 创建分支
   *
   * @generated from rpc puppy.proto.v1.VersionControlService.CreateBranch
   */
  createBranch: {
    methodKind: "unary";
    input: typeof CreateBranchRequestSchema;
    output: typeof BranchInfoSchema;
  },
  /**
   * 创建标签
   *
   * @generated from rpc puppy.proto.v1.VersionControlService.CreateTag
   */
  createTag: {
    methodKind: "unary";
    input: typeof CreateTagRequestSchema;
    output: typeof TagInfoSchema;
  },
  /**
   * 删除分支
   *
   * @generated from rpc puppy.proto.v1.VersionControlService.DeleteBranch
   */
  deleteBranch: {
    methodKind: "unary";
    input: typeof DeleteBranchRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * 删除标签
   *
   * @generated from rpc puppy.proto.v1.VersionControlService.DeleteTag
   */
  deleteTag: {
    methodKind: "unary";
    input: typeof DeleteTagRequestSchema;
    output: typeof EmptyResponseSchema;
  },
  /**
   * 合并分支
   *
   * @generated from rpc puppy.proto.v1.VersionControlService.MergeBranch
   */
  mergeBranch: {
    methodKind: "unary";
    input: typeof MergeBranchRequestSchema;
    output: typeof MergeResultSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_version, 0);

